import type { Store, StoreState } from 'src/store/types';

export const actions = (_: Store) => ({
  setAdvertiserInfo: (
    storeState: StoreState,
    {
      advertiserId,
      seekAdvertiserId,
      seekBillingAccountId,
      userEmail,
      adCentreUserId,
      firstName,
      lastName,
    }: {
      advertiserId: string;
      seekAdvertiserId: string;
      seekBillingAccountId: string;
      userEmail: string;
      adCentreUserId: string;
      firstName: string;
      lastName: string;
    },
  ) => ({
    advertiserId,
    seekAdvertiserId,
    seekBillingAccountId,
    userEmail,
    adCentreUserId,
    firstName,
    lastName,
  }),
  setIsAdministrator: (
    storeState: StoreState,
    { isAdministrator }: { isAdministrator: boolean },
  ) => ({ isAdministrator }),
  setIsLoading: (
    storeState: StoreState,
    { isLoading }: { isLoading: boolean },
  ) => ({ isLoading }),
});
